module.exports = __webpack_public_path__ + "static/media/wln.3c73006a.jpg";